import {serializable, alias, primitive} from 'serializr';

export class DicomData {
    @serializable(alias('file', primitive()))
    file?: string;
}
